import React from 'react';
import SectionList from '../SectionList';
// import Lesson from '../Lesson';
// import List from '../List';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';

function Course({ data }) {
  const { selectedCourseTitle } = React.useContext(DataContext);

  function removeLeadingNumber(title) {
    return title.replace(/^\d+\.\s*/, '');
  }
  const title = removeLeadingNumber(selectedCourseTitle);

  const courseContents = (
    <>
      <CourseTitle>{title}</CourseTitle>
      <SectionList />
      {/* <List /> */}
      {/* <div>
        {data.map((item, index) => (
          <Lesson key={`${item.episode_number}-${index}`} item={item} />
        ))}
      </div> */}
    </>
  );

  return courseContents;
}

export default Course;

const CourseTitle = styled.h1`
  font-size: 20px;
  text-align: left;
`;
